/*
 * @author Mateusz Mieszczak <mateusz.mieszczak at bossbyte.com>
 * @copyright BossByte Web Application
 */


app.controller('MessageDetails', function($scope, $rootScope, mailboxService, recipientService, $stateParams,
    Upload, _$privileges, _$editmode) {

    _$editmode.turnOff();

    $scope.id = $stateParams.id;

    $scope.tab = {
        "selected": 0,
        "change": function(kind) {
            $scope.tab.selected = kind == 'next' ? $scope.tab.selected + 1 : $scope.tab.selected - 1;
        },
        "title": $scope.id ? "" : "Nowa wiadomość",
        "kind": "",
        "editable": false,
        "button": "Wyślij",
        "details": true
    };

    $scope.data = {
        "categories": [],
        "notifications": [],
        "sended_notifications": [],
        "receiver_list": [],
        "subunit": false,
        "subunit_id": false,
        "can_write": false,
        "emailsettings": {},
        "unitSupported": false,
        "teamSupported": false,
        "languages": [],
        "activeNotifications": []
    };

    $scope.row = {
        'send_date': '',
        'ready_to_send': '',
        'send_now': false,
        'mobile_available': '',
        'content': {
            'only_sms': false,
            'subject': '',
            'notification_category_id': '',
            'short_msg': '',
            'long_msg': '',
            'photo': '',
            'link': '',
            'lat': null,
            'lng': null,
            'filter': {
                'all': 1,
                'kind': ''
            },
            'attachment': [],
            'notification': [],
            'receiver': []
        },
        'scheduler': {
            'send_type': '',
            'repeat_unit': '',
            'send_from': '',
            'send_to': '',
            'date': []
        },
        'actions': {
            'template': {
                'set': false,
                'name': ''
            },
            'receivergroup': {
                'set': false,
                'name': ''
            }
        }
    };

    $scope.autocompletes = {
        "county": [],
        "city": [],
        "comunity": [],
        "street": []
    };

    $scope.search = {
        clearButton: false,
        list: {}
    };

    $scope.notavailable = {
        "sms": false,
        "mobile": true,
        "email": false,
        "epuap": false,
        "available_to": true
    };

    $scope.mobileNotificationId;

    /*
     * pagination
     */

    $scope.queue = {
        "clearButton": false,
        "filter": {
            "name": "",
            "surname": "",
            "notificationId": ""
        },
        "pagination": {
            currentPage: 1,
            totalItems: 1,
            itemsPerPage: 1
        },
        "get": function() {
            $scope.queue.filter.id = $scope.row.id;
            var promise = mailboxService.mailboxqueue($scope.queue.pagination.currentPage, $scope.queue.filter);
            promise.then(function(payload) {
                if ($scope.queue.filter.name != "" || $scope.queue.filter.surname != "" || $scope.queue.filter.notificationId != 0)
                    $scope.queue.clearButton = true;
                $scope.data.sended_queue.data = payload.data.data;
                $scope.queue.pagination.totalItems = payload.data.total;
                $scope.queue.pagination.itemsPerPage = payload.data.per_page;
                $scope.queue.pagination.currentPage = payload.data.current_page;
            });
        },
        "clear": function() {
            $scope.queue.filter.name = $scope.queue.filter.surname = "";
            $scope.queue.filter.notificationId = 0;
            $scope.queue.clearButton = false;
            $scope.queue.pagination.currentPage = 1;
            $scope.queue.get();
        }
    };

    $scope.setPage = function() {
        $scope.showLoader = true;
        //$scope.list.request($scope.pagination.currentPage);
    };

    $scope.init = function() {
        $scope.data.can_write = _$privileges.write("message");

        var promise;

        if ($stateParams.ids)
            promise = mailboxService.create($stateParams.ids);
        else
            promise = $scope.id ? mailboxService.show($scope.id) : mailboxService.create();
        promise.then(
            function(payload) {
                $scope.data.subunit = payload.data.subunit;
                $scope.data.subunit_id = payload.data.subunit_id;

                $scope.data.teamSupported = payload.data.teamSupported;
                $scope.data.subunitSupported = payload.data.subunitSupported;

                $scope.data.activeNotifications = payload.data.activeNotifications;

                $rootScope.filters = payload.data.filters;
                $scope.data.categories = payload.data.categories;
                $scope.data.languages = payload.data.languages;
                $scope.data.notifications = payload.data.notifications;
                $scope.data.available_notifications = payload.data.available_notifications;
                $scope.data.subunit = payload.data.subunit;
                $scope.data.subunit_id = payload.data.subunit_id;
                $scope.data.emailsettings = payload.data.emailsettings;
                $scope.search.list = payload.data.list;

                if (typeof payload.data.sended_queue != "undefined") {
                    $scope.data.sended_queue = payload.data.sended_queue;
                    $scope.queue.pagination = {
                        totalItems: $scope.data.sended_queue.total,
                        currentPage: $scope.data.sended_queue.current_page,
                        itemsPerPage: $scope.data.sended_queue.per_page
                    };
                }

                $scope.row = payload.data.row;

                if (typeof $stateParams.signed !== "undefined" && $stateParams.signed!=null) {
                    if ($stateParams.signed == 1) {
                        if($scope.row.epuap){
                          $scope.row.epuap.signed = 1;
                          mailboxService.confirmEpuapSign($scope.id);
                        }
                        $rootScope.notification.show('success', 'Dokument został podpisany');
                    } else {
                        $rootScope.notification.show('error', 'Nie udało się podpisać dokumentu');
                    }
                }

                if (typeof payload.data.receivers != "undefined") {
                    $scope.data.receivers = payload.data.receivers;
                    $scope.row.content.receiver = payload.data.receiverlist;
                }

                $scope.data.sended_notifications = payload.data.sended_notifications;

                if ($scope.id) {
                    if (payload.data.row.length == 0) {
                        $rootScope.notification.showAfterRedirect('message_msgnew', {}, 'error', 'Wiadomość nie została odnaleziona');
                    } else {
                        $scope.row = payload.data.row;

                        if ($scope.row.content.filter.county != null && $scope.row.content.filter.county != "") {
                            var county = $scope.row.content.filter.county.split(",");

                            for (var i = 0; i < county.length; i++) {
                                if (county[i] != "") {
                                    $scope.autocompletes.county.push({
                                        name: county[i],
                                        readonly: true
                                    });
                                }
                            }
                        }

                        if ($scope.row.content.filter.comunity != null && $scope.row.content.filter.comunity != "") {
                            var comunity = $scope.row.content.filter.comunity.split(",");
                            for (var i = 0; i < comunity.length; i++) {
                                if (comunity[i] != "") {
                                    $scope.autocompletes.comunity.push({
                                        name: comunity[i],
                                        readonly: true
                                    });
                                }
                            }
                        }

                        if ($scope.row.content.filter.city != null && $scope.row.content.filter.city != "") {
                            var city = $scope.row.content.filter.city.split(",");
                            for (var i = 0; i < city.length; i++) {
                                if (city[i] != "") {
                                    $scope.autocompletes.city.push({
                                        name: city[i],
                                        readonly: true
                                    });
                                }
                            }
                        }

                        if ($scope.row.content.filter.street != null && $scope.row.content.filter.street != "") {
                            var street = $scope.row.content.filter.street.split(",");
                            for (var i = 0; i < street.length; i++) {
                                if (street[i] != "") {
                                    $scope.autocompletes.street.push({
                                        name: street[i],
                                        readonly: true
                                    });
                                }
                            }
                        }

                        if ($scope.row.mobile_available != "") {
                            $scope.row.mobile_available = $rootScope.formatDate($scope.row.mobile_available);
                            $scope.row.send_date = $rootScope.formatDate($scope.row.send_date);
                        }

                        if ($scope.row.scheduler) {
                            if ($scope.row.scheduler.send_type == "repeat") {
                                $scope.row.scheduler.send_from = $rootScope.formatDate($scope.row.scheduler.send_from);
                                $scope.row.scheduler.send_to = $rootScope.formatDate($scope.row.scheduler.send_to);
                            } else if ($scope.row.scheduler.send_type == "scheduler") {
                                for (var i = 0; i < $scope.row.scheduler.date.length; i++) {
                                    $scope.row.scheduler.date[i].send_date = $rootScope.formatDate($scope.row.scheduler.date[i].send_date);
                                }
                            }
                        }

                        if ($scope.row.content.mobile_msg != ""){
                            $scope.notavailable.mobile = false;
                            $scope.notavailable.email = false;
                        }

                        if (typeof payload.data.receiver_list != "undefined")
                            $scope.data.receiver_list = payload.data.receiver_list;

                        $scope.row.priority = payload.data.row.content.notification;

                        for (var i = 0; i < $scope.data.notifications.length; i++) {
                            if ($scope.data.notifications[i].symbol == "mobile")
                                $scope.mobileNotificationId = "" + $scope.data.notifications[i].id;
                        }

                        $scope.notavailable.available_to = $scope.row.content.notification.indexOf(parseInt($scope.mobileNotificationId)) == -1;

                        var date = new Date();
                        var month = (parseInt(date.getMonth(), 10) + 1);
                        var dateString = date.getFullYear() + "-" + (month < 10 ? "0" : "") + month + "-" + date.getDate();

                        if ($scope.row.draft) {
                            $scope.tab.kind = "draft";
                            $scope.tab.title = ($scope.tab.editable ? "Edycja" : "Szczegóły") + " wiadomości roboczej";
                            $scope.tab.action = "drafts";
                        } else if($scope.row.send_now == 1 && $scope.row.epuap!=null && $scope.row.epuap.signed==0){
                            $scope.tab.kind = "send";
                            $scope.tab.title = "Szczegóły wiadomości oczekującej";
                            $scope.tab.action = "send";
                        } else if ($scope.row.send_now == 1 || $scope.row.send_date <= dateString) {
                            $scope.tab.kind = "send";
                            $scope.tab.title = "Szczegóły wiadomości wysłanej";
                            $scope.tab.action = "send";
                        } else if ($scope.row.send_now == 0 || $scope.row.send_date > dateString) {
                            $scope.tab.kind = "outbox";
                            $scope.tab.title = "Szczegóły wiadomości oczekującej";
                            $scope.tab.action = "waiting";
                        }

                        if (typeof $scope.row != "undefined" && $scope.row.content.filter.age != null && $scope.row.content.filter.age != "") {
                            var age = $scope.row.content.filter.age.split("_");
                            if (age[0] == "date") {
                                $scope.row.content.filter.age_before = new Date($scope.row.content.filter.age_before);
                                if ($scope.row.content.filter.age_after != "")
                                    $scope.row.content.filter.age_before = new Date($scope.row.content.filter.age_before);
                            } else {
                                $scope.row.content.filter.age_before = parseInt($scope.row.content.filter.age_before, 10);
                                if ($scope.row.content.filter.age_after != "")
                                    $scope.row.content.filter.age_after = parseInt($scope.row.content.filter.age_after, 10);
                            }
                        }
                    }
                }
            });
    };

    $scope.init();

    $scope.sendMethodChange = function() {

    };

    $scope.sendagain = function() {
        var promise = mailboxService.sendagain($scope.id);
        promise.then(
            function(payload) {
                $rootScope.notification.show(payload.data.code ? 'success' : 'error', payload.data.msg);
            });
    };

    $scope.delete = function() {
        var promise = mailboxService.delete($scope.id ? $scope.id : $rootScope.checkboxList.ids);
        promise.then(
            function(payload) {
                if (payload.data.code == 1) {
                    var action = 'message_' + $scope.tab.action;
                    $rootScope.notification.showAfterRedirect(action, {}, 'success', payload.data.msg);
                    $rootScope.checkboxList.clear();
                } else {
                    $rootScope.notification.show('error', payload.data.msg);
                }
            });
    };

    $scope.signEpuap = function(mailboxId) {
        var promise = mailboxService.adddocumenttosigning(mailboxId);
        promise.then(
            function(payload) {
                if (payload.data.code == 0) {
                    $rootScope.notification.show('error', payload.data.msg);
                } else {
                    top.location.href = payload.data.msg.addDocumentToSigningReturn;
                }
            });
    };
});
